import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Order extends Form {

    constructor(auth, data = [], reference) {
        super(data);

        this.reference = reference ?? this.generateOrderReference('SR-', auth);
        this.order = false;
        this.order_items = false;

        this.export_format = 'Csv';
        this.order_type = 'bulk';

        this.order_currency = null;
        this.item_details = false;

        this.order_exception = false;

        this.resetFilters().then(r => {});
    }

    resetFilters() {
        let self = this;

        return new Promise(resolve => {
            self.filters = {
                query: null,
                status: null
            };

            resolve(true);
        });
    }

    ordersAvailable() {
        if (this.index_data && this.index_data.data) {
            return this.index_data.data.length > 0;
        }

        return false;
    }

    showOrder(reference) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = self.api_prefix + '/order/' + self.reference + '/details';

            axios.get(uri)
                .then(response => {
                    self.order = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    loadOrderItems(reference) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = self.api_prefix + '/order/item/' + self.reference + '/details';

            axios.get(uri)
                .then(response => {
                    self.order_items = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    history(append = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = '/api/order/history?page=' + self.page + '&type=' + self.type;

            if (this.filters) {
                let query = this.filters.query ? this.filters.query : null;
                uri = uri + '&q=' + query + '&status=' + this.filters.status;
            }

            axios.get(uri, self.data)
                .then(response => {
                    let result = response.data;

                    self.processIndexData(result, append);

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    details(uuid) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/order/history/' + uuid, self.data)
                .then(response => {

                    this.item_details = response.data;

                    resolve(this.item_details);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    createOrder() {
        let self = this;

        self.setFormUpdating();

        return new Promise((resolve, reject) => {
            axios.post('/api/v2/order/bulk', self.buildOrderData(), {
                headers: {
                    'X-Max-Wait': 0
                }
            }).then(response => {
                resolve(response.data.data);
                self.setFormUpdateComplete()
            }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

    buildOrderData() {
        let data = {
            reference: this.reference,
            order_type: this.order_type,
            items: []
        };

        for (let i = 0; i < this.data.length; i++) {
            let item = { ...this.data[i] }

            item.quantity = Number.parseInt(item.quantity);
            item.value = this.convertOrderValue(item.value);

            data.items.push(item);

        }

        return data;
    }

    convertOrderValue(value) {
        return Number.parseInt(parseFloat(value) * 100);
    }

    addProductToOrder(product, attributes) {
        let self = this;

        return new Promise((resolve, reject) => {
            // set order currency to prevent cross currency orders
            if (!self.order_currency) {
                self.order_currency = product.currency;
            }

            let item = {
                sku: product.sku,
                value: attributes.value,
                quantity: (attributes.pan || attributes.serial) ? 1 : attributes.quantity,
                pan: attributes.pan ?? null,
                serial: attributes.serial ?? null,
                delivery: false
            };

            self.preflightOrderItem(item).then(r => {
                self.data.push(item);

                resolve(true);
            }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

    generateOrderReference(prefix, auth, length = 8)  {
        let ref = '';

        if (auth) {
            let name = auth.account_name.replace(' ', '');

            ref = name.substr(0, 4).toLowerCase();
        }

        return prefix + ref + Math.random().toString(20).substr(2, length);
    }

    preflightOrderItem(data = {}) {
        let self = this;

        return new Promise((resolve, reject) => {

            self.resetFormMessages().then(result => {
                self.setFormUpdating();
            });

            const requestData = {
                sku: data.sku,
                quantity: Number.parseInt(data.quantity),
                value: self.convertOrderValue(data.value),
            };

            if (data.pan) {
                requestData.pan = data.pan;
            }

            if (data.serial) {
                requestData.serial = data.serial;
            }

            axios.post('/api/preflight/order/item', requestData)
                .then(response => {
                    self.setFormUpdateComplete();

                    resolve(response);
                }).catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    refundItem(itemUuid) {
        let self = this;
        return new Promise((resolve, reject) => {
            axios.post('/api/order/item/'+itemUuid+'/refund').then(response => {
                resolve(response);
            }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

    cancelOrder(reference) {
        let self = this;
        return new Promise((resolve, reject) => {
            axios.delete('/api/order/cancel/'+reference).then(response => {
                resolve(response);
            }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

    reprocessOrder(reference) {
        let self = this;
        return new Promise((resolve, reject) => {
            axios.patch('/api/order/reprocess/',{
                reference: reference,
            }).then(response => {
                resolve(response);
            }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

    showOrderException(reference) {
        let self = this;

        return new Promise((resolve, reject) => {
            let uri = self.api_prefix + '/order/' + self.reference + '/details/exception';

            axios.get(uri)
                .then(response => {
                    self.order_exception = response.data.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                })
        });
    }

    async updateOrderStatus(reference, status) {
        if (! reference) reference = this.order.reference;
        if (! status) status = this.order.status;

        return new Promise((resolve, reject) => {
            axios.patch('/api/order/' + reference + '/update-status',{
                update_status: status,
            }).then(response => {
                resolve(response);
            }).catch(error => {
                this.setError(error);
                reject(error);
            });
        });
    }

}
